import commonConfig from './common';

const ENV = import.meta.env.VITE_ENV;

const getConfig = () => ({
  ...commonConfig,
  isLocal: import.meta.env.DEV,
  isDevelopment: ENV === 'development',
  isStaging: ENV === 'staging',
  isProduction: ENV === 'production',
});

const config = getConfig();

export default config;
